import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { candidateTypeCounts } from "@/Constants/common";
import {
  _fetchFilterData,
  _removeCandidateStatus,
  _shortListCandidates,
  _unSuitableCandidates,
} from "@/services/clientcandidates";
import { handleAPICatch, showSuccessToast } from "@/utilities/utils";

import { toggleMarkAsUnsuitableReasonModal } from "./clientcommon";

const initialState = {
  isLoading: false,
  typeCount: candidateTypeCounts,
  filterLists: {},
};
export const shortListCandidates = createAsyncThunk(
  "clientsCandidate/shortListCandidates",
  async (data, thunkAPI) => {
    const {
      candidate_ids,
      callback,
      loading,
      setLoading,
      page = "",
      isSelectedAll = false,
      ignoreIds = "",
    } = data;
    if (loading) return;
    setLoading(true);
    const response = _shortListCandidates({
      candidate_ids: isSelectedAll ? "" : candidate_ids.join(","),
      ignoreIds,
      page,
      isSelectedAll,
    });
    response
      .then((res) => {
        const {
          data: { message },
        } = res;
        showSuccessToast(message);
        callback &&
          callback(0, 1, isSelectedAll, ignoreIds.split(","), candidate_ids);
      })
      .catch((error) => {
        // logger.error(error);
        // console.log(error)
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);
export const unSuitableCandidates = createAsyncThunk(
  "clientsCandidate/unSuitableCandidates",
  async (data, thunkAPI) => {
    const {
      candidate_ids,
      callback,
      loading,
      setLoading,
      page = "",
      isSelectedAll = false,
      ignoreIds = "",
      reason,
    } = data;
    if (loading) return;
    setLoading(true);
    const response = _unSuitableCandidates({
      candidate_ids: isSelectedAll ? "" : candidate_ids.join(","),
      page,
      isSelectedAll,
      ignoreIds,
      reason,
    });
    response
      .then((res) => {
        const {
          data: { message },
        } = res;
        thunkAPI.dispatch(toggleMarkAsUnsuitableReasonModal(false));
        showSuccessToast(message);
        callback &&
          callback(1, 0, isSelectedAll, ignoreIds.split(","), candidate_ids);
      })
      .catch((error) => {
        // logger.error(error);
        // console.log(error)
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);
export const removeCandidateStatus = createAsyncThunk(
  "clientsCandidate/removeCandidateStatus",
  async (data, thunkAPI) => {
    const {
      candidate_ids,
      callback,
      loading,
      setLoading,
      page = "",
      isSelectedAll = false,
      ignoreIds = "",
    } = data;
    if (loading) return;
    setLoading(true);
    const response = _removeCandidateStatus({
      candidate_ids: isSelectedAll ? "" : candidate_ids.join(","),
      page,
      isSelectedAll,
      ignoreIds,
    });
    response
      .then((res) => {
        const {
          data: { message },
        } = res;
        showSuccessToast(message);
        callback &&
          callback(0, 0, isSelectedAll, ignoreIds.split(","), candidate_ids);
      })
      .catch((error) => {
        // console.log(error)
        // logger.error(error);
        handleAPICatch(error);
      })
      .finally(() => {
        setLoading(false);
      });
  },
);
export const fetchFiltersData = createAsyncThunk(
  "clientsCandidate/fetchFiltersData",
  async (data, thunkAPI) => {
    await new Promise((resolve) => setTimeout(resolve, 450));
    const response = _fetchFilterData();
    response
      .then((res) => {
        const { data } = res;
        let allRoles = [];
        let allCandidates = [];
        let allUsers = [];
        if (data.all_roles) {
          allRoles = Object.keys(data.all_roles).map((key) => {
            return {
              name: data.all_roles[key],
              value: key,
            };
          });
        }

        if (data.all_worked_candidate) {
          allCandidates = Object.keys(data.all_worked_candidate).map((key) => {
            return {
              name: data.all_worked_candidate[key],
              value: key,
            };
          });
        }
        if (data?.all_users) {
          allUsers = data?.all_users.map((key) => {
            return {
              value: key.id,
              name: key.name,
              type: key.type,
            };
          });
        }

        // console.log("allUsers-------:", allUsers)
        thunkAPI.dispatch(
          updateFilterLists({
            allRoles,
            allCandidates,
            allUsers,
          }),
        );
      })
      .catch((error) => {
        // handleAPICatch(error);
        return thunkAPI.rejectWithValue(error);
      });
  },
);

const clientsCandidateSlice = createSlice({
  name: "clientCandidate",
  initialState,
  reducers: {
    /**
     * Updates the type count in the state.
     *
     * @param {Object} state - The current state object
     * @param {Object} action - The action object containing the payload
     * @return {void}
     */
    updateTypeCount: (state, action) => {
      state.typeCount = action.payload;
    },
    /**
     * Updates the filter lists in the state with the provided payload.
     *
     * @param {type} state - the current state
     * @param {type} action - the action containing the payload
     * @return {type} undefined
     */
    updateFilterLists: (state, action) => {
      state.filterLists = action.payload;
    },
  },
});

export const { updateTypeCount, updateFilterLists } =
  clientsCandidateSlice.actions;

export default clientsCandidateSlice.reducer;
